/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDNEWNOTE,ADDNEWNOTE_RECEIVED } = constants.AddNewNoteConstant;

export default {
    REQUEST_ADDNEWNOTE,
    ADDNEWNOTE_RECEIVED,

  requestAddNewNote: payload => ({
    type: REQUEST_ADDNEWNOTE,
    payload
  }),
  AddNewNoteReceived: () => ({
    type: ADDNEWNOTE_RECEIVED
  }),
};
